// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__38pVA","header":"PatientQuestionnaire_header__c-awm","info":"PatientQuestionnaire_info__19yGE"};